import theme from '@styles/theme';
export default {
  container: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: theme.zIndex.alerts,
    display: 'flex'
  },
  alertContainer: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    padding: ['0 16px', '0 16px', '0']
  },
  alertContent: {
    height: 'auto',
    width: '100%',
    maxWidth: '525px',
    backgroundColor: `${theme.rawColors.neutralWhite}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    padding: ['29px 16px', '29px 16px', '24px', '24px', '40px']
  },
  message: {
    color: theme.rawColors.darkGrey700,
    fontSize: theme.fontSizes.text,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '140%',
    whiteSpace: 'break-spaces',
    paddingBottom: '24px'
  },
  overlay: {
    backgroundColor: theme.rawColors.darkGrey700,
    opacity: 0.25,
    position: 'fixed',
    left: 0,
    top: 0,
    height: '100%',
    width: '100%'
  }
};